import { render, staticRenderFns } from "./Samples.vue?vue&type=template&id=624ef6e8&scoped=true&"
import script from "./Samples.vue?vue&type=script&lang=js&"
export * from "./Samples.vue?vue&type=script&lang=js&"
import style0 from "./Samples.vue?vue&type=style&index=0&id=624ef6e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624ef6e8",
  null
  
)

export default component.exports